import { useRecoilValue } from 'recoil';
import { selectedPlaceIdState } from '../../storage/places';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { PlaceDetail } from '../places/PlaceDetail';
import { PlaceList } from '../places/PlaceList';
import { PlacesProvider } from '../providers/PlacesProvider';

export function PlacesPage() {
  const selectedPlaceId = useRecoilValue(selectedPlaceIdState);

  return (
    <>
      <PlacesProvider />
      <FloatingCardsLayout
        contentSize={350}
        list={<PlaceList />}
        content={selectedPlaceId !== undefined && <PlaceDetail />}
      />
    </>
  );
}
